import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=6f5ca8ec&scoped=true&"
import script from "./Logo.vue?vue&type=script&lang=js&"
export * from "./Logo.vue?vue&type=script&lang=js&"
import style0 from "./Logo.vue?vue&type=style&index=0&id=6f5ca8ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5ca8ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1768404630/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f5ca8ec')) {
      api.createRecord('6f5ca8ec', component.options)
    } else {
      api.reload('6f5ca8ec', component.options)
    }
    module.hot.accept("./Logo.vue?vue&type=template&id=6f5ca8ec&scoped=true&", function () {
      api.rerender('6f5ca8ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/NewUI/containers/core/leftNavBar/Logo.vue"
export default component.exports